import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ReserveProvider } from '../providers/reserves';

@Pipe({
  name: 'entityReserveUserData'
})

export class EntityReserveDataPipe implements PipeTransform {

  constructor(
    private reserveData: ReserveProvider
  ) { }

  transform(reserveUser: any): Observable<any> {
    return this.reserveData.getEntityData(reserveUser.type, reserveUser.idObject, reserveUser.eventId);

  }
}


// WEBPACK FOOTER //
// ./src/pipes/entityReserveData.pipe.ts